import {createAction, props} from "@ngrx/store";
import {FavoriteEntityType} from "../../enums/favorite-entity-type";
import {FavoriteId} from "../../ts-types/favorite-id";


export const toggleFavorite = createAction(
  '[User] Toggle Favorite',
  props<{ entityType: FavoriteEntityType, id: FavoriteId }>()
);

export const addFavorite = createAction(
  '[User] Add Favorite',
  props<{ entityType: FavoriteEntityType, id: FavoriteId }>()
);

export const removeFavorite = createAction(
  '[User] Remove Favorite',
  props<{ id: FavoriteId }>()
);

export const clearFavorites = createAction(
  '[User] Clear Favorites'
);

export const setFavoritesCode = createAction(
  '[User] Set Favorites Code',
  props<{ code: string }>()
);


export const toggleSelfAssessedRequirement = createAction(
  '[User] Toggle Self Assessed Requirement',
  props<{ bicId: number, requirementId: number }>()
);

export const clearSelfAssessedBicId = createAction(
  '[User] Clear Self Assessed Requirements By Bic Id',
  props<{ bicId: number }>()
);

export const clearAllSelfAssessedRequirements = createAction(
  '[User] Clear All Self Assessed Requirements'
);

export const updateSelfAssessedRequirementsTimeout = createAction(
  '[User] Set next 30 Min. Timeout for self assessment session'
);

export const resetSelfAssessedRequirementsTimeout = createAction(
  '[User] Reset timeout due to inactivity'
);

export const setAcceptCookieDate = createAction(
  '[User] Set last date cookie accepted'
);

